import { Component, OnInit, DoCheck, HostListener, ViewChild, ElementRef, NgZone , ViewChildren} from '@angular/core';
import * as $ from 'jquery';
import * as SockJS from 'sockjs-client';
import * as Stomp from 'stompjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RestDataService } from '../../service/rest-data.service';
import { Config } from '../../config/config';
import { StaticDataService } from '../../service/static-data.service';
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from '../../service/shared-data.service';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Unlisten } from '../../keyboard-shortcuts/keyboard-shortcuts';
import { SnotifyService } from 'ng-snotify';
import { DomSanitizer } from '@angular/platform-browser';
import { PageListingComponent } from '../page-listing/page-listing.component';
import { ThrowStmt } from '@angular/compiler';
import { LocalstorageService } from '../../service/localstorage.service';
import { environment } from '../../../environments/environment';
import Editor from "../../../assets/js/ckeditor";
import { CKEditorComponent, ChangeEvent } from '@ckeditor/ckeditor5-angular';
import * as moment from 'moment';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
@Component({
  selector: 'app-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss']
})
export class PageContainerComponent implements OnInit, OnDestroy, DoCheck {
  subscription: Subscription;
  lastPageData = null;
  Category = 'story';
  id = this.route.snapshot.paramMap.get('id');
  page_id = StaticDataService.page_id;
  save_api = StaticDataService.page_save_api;
  get_api = StaticDataService.page_get_api;
  version_api = StaticDataService.page_version_api;
  lockAcquire_api = StaticDataService.page_lockAcquire_api;
  lockRelease_api = StaticDataService.page_lockRelease_api;
  unLockPage = StaticDataService.page_unlock_api;
  serverUrl = this.config.get('product').socketUrl;
  stompClient = null;
  deleteArticleFromPage = StaticDataService.page_delete_articlefrompage;
  autosave = null;
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  showlockBg = false;
  newMetas = [];
  pageLoaded = false;
  publishFlag = false;
  pageEditMode = false;
  firstLoadCheck = 0;
  changeFlag = false;
  selectedFile: File = null;
  pageData: any;
  pageQuery = 'list';
  pageDesign = [];
  pushPinnedArticles = [];
  filteredpageDesign = [];
  ImageUrl: string;
  mergeArray: string;
  listOfHistoryArray: any[] = [];
  private unlisten: Unlisten;
  compareFn = this._compareFn.bind(this);
  currentDomain: string;
  pageType: string;
  defaultPageData = {
    'id': null,
    'url': null,
    'name': null,
    'title': null,
    'domainId': sessionStorage.getItem(StaticDataService.domainLiteral),
    'keywords': [],
    'synonymsList': [],
    'description': null,
    'about': null,
    'parentSection': null,
    'lastUpdated': null,
    'status': 'CREATED',
    'lastModifiedBy': null,
    'lastPublishedDate': null,
    'lastModifiedDate': null,
    'lastPublishedBy': null,
    'creationDate': null,
    'pageType': null,
    'category': null,
    'lockedByUserId': null,
    'lockedByUserName': null,
    'lockedDate': null,
    'coverImage': null,
    'pinnedArticles': null,
    'pageArticles': []
  };

  fieldSet = [
    // {
    //   labelName: 'By Line',
    //   focusFlag: false,
    //   dataModelId: 'storyData.metadata.authors',
    //   metadataModelId: 'authors',
    //   inputPlaceholder: 'Add by line here'
    // },
    {
      labelName: 'Reported By',
      focusFlag: false,
      dataModelId: 'pageData.metadata.reportedBy',
      metadataModelId: 'reportedBy',
      inputPlaceholder: 'Name of Reporter(s)',
      auto: true
    },
    {
      labelName: 'Written By',
      focusFlag: false,
      dataModelId: 'pageData.metadata.writtenBy',
      metadataModelId: 'writtenBy',
      inputPlaceholder: 'Name of Writer(s)',
      auto: true
    },
    {
      labelName: 'Edited By',
      focusFlag: false,
      dataModelId: 'pageData.metadata.editedBy',
      metadataModelId: 'editedBy',
      inputPlaceholder: 'Name of Editor(s)',
      auto: true
    },
    {
      labelName: 'Agency By Line',
      focusFlag: false,
      dataModelId: 'pageData.metadata.agencyByLine',
      metadataModelId: 'agencyByLine',
      inputPlaceholder: 'Ageny\'s Author',
      auto: false
    },
  ];
  validationFlag = false;
  errorDisplayArray = [];
  innerFocusFlag = false;
  insideColumn = false;
  filteredColumnSuggestion = [];
  columnQuery = '';
  columnSuggestion = [];
  @ViewChild('columnList',{static: false}) columnList;
  @ViewChild('sectionList',{static: false}) sectionList;
  @ViewChild('subSectionList',{static: false}) subSectionList;
  @ViewChildren('columnInput') columnField;
  @ViewChildren('sectionInput') sectionField;
  @ViewChildren('subSectionInput') subSectionField;

  lastindex = null;
  currentSelection = 0;
  isMoreButtonEnabled = false;
  disabledMetaFields = [];
  metaToggleFlag = true;
  authorsSuggestion = [];

  isLocked = false;

  @ViewChild('designOptions', {static: false}) designOptionsDropdown: ElementRef;
  cropperImageUrl = {
    url: null,
    data: null
  };
  showCropper = false;
  subscriptions: Subscription[] = [];
  previewPopup = false;
  previewUrl = null;
  previewPlatform = null;
  iframeStyle = null;
  iframeLoading = 0;
  templateTypes = [];
  templateType = null;
  allCollections = [];
  disabledPreviews = [];
  @ViewChild('secondaryCTAs', {static: false}) secondaryCTA: ElementRef;
  revertListFlag = false;
  componentDesigns = [];
  allCollectionsMeta = {};

  domainConfig = {};
  @ViewChild('lineupElement', {static: false}) lineupElement: PageListingComponent;
  deleteLineupPopup = false;
  ckconfig = {
    toolbar: ['link'],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
              target: '_blank'
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };
  infoEditor;
  descriptionEditor;
  public ckEditor = Editor;
  public ckEditor2 = Editor;
  descriptionFocusFlag = false;
  infoFocusFlag = false;
  @ViewChild('descEl', {static: false}) descriptionElement: ElementRef;
  @ViewChild('infoEl', {static: false}) infoElement: ElementRef;
  saveInQueue = 0;
  pickStoryImageLoad = false;
  croppingInProgress = false;
  imageType: string;
  sponsorImageFlag = false;
  pagesDisabled = [];
  sectionQuery =  '';
  insideSection = false;
  insideSubSection = false;
  filteredSectionSuggestion: any;
  subSectionQuery = '';
  sectionSuggestion = [];
  filteredSubSectionSuggestion: any;
  allSubSections = [];
  subSectionSuggestion = [];
  autocompletelist: any = [];
  accessType = "";
  user: any;
  viewPortItems = [];
  contentChecked = false;
  todayDate:any;
  @ViewChild('editorAdditionalInfo',{static:false})
  editorAdditionalInfo: CKEditorComponent;
  @ViewChild('editorDescription',{static:false})
  editorDescription: CKEditorComponent;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snotify: SnotifyService,
    private http: HttpClient,
    private sharedService: SharedDataService,
    private restService: RestDataService,
    private config: Config,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private localstorageService:LocalstorageService,
    private gaService:GoogleAnalyticsService,
  ) {
    this.snotify.clear();
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    this.disabledPreviews = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['disabledMeta']
    && this.domainConfig['config']['disabledMeta']['preview']) ? this.domainConfig['config']['disabledMeta']['preview'].split(',') : [];
    this.newMetas = this.domainConfig['pageDynamicMeta'];
    console.log(this.newMetas)
    this.getAccessType();
  }
  getAccessType(){
      const product = this.config.get('product');
      const baseUrl = product.baseUrl;
      const endPoint = this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api);
      const url = baseUrl + endPoint + '/' + this.id;
  
      this.restService.http_get(url)
        .subscribe(data => {
          this.pageData = data;
          const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
          this.user = this.restService.userDetail;
          const permissions = this.user.domainPermissions[currentDomain].page;
          for (const obj of permissions) {
            if (obj.name === this.pageData.pageType) {
              this.accessType = obj.accessType;
              break;
            }
          }
        });
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.disabledMetaFields = (this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['disabledPageMeta']
    && this.domainConfig['config']['disabledPageMeta']['fields'])
    ? this.domainConfig['config']['disabledPageMeta']['fields'].split(',') : [];
    const metaSet = this.fieldSet.map(e => e.metadataModelId).concat(['column']).filter(e => (this.disabledMetaFields.indexOf(e) === -1));
    this.isMoreButtonEnabled = metaSet.length > 0;
    this.pagesDisabled = this.domainConfig['pagesDisabled'] || [];
  }

  updateEditionDate(event) {
    let date = moment.utc(moment(event).utc()).format();
    this.pageData.editionDate = date.replace('Z', '+0000') 
  }

  ckEditorReadOnlyDisabled() {
    if(this.descriptionEditor && !this.pageEditMode){
      this.descriptionEditor.enableReadOnlyMode('editor');
    } 
    if(this.infoEditor && !this.pageEditMode){
      this.infoEditor.enableReadOnlyMode('editor');
    } 
    if(this.descriptionEditor && this.pageEditMode) {
      this.descriptionEditor.disableReadOnlyMode('editor');
    }
    if(this.infoEditor && this.pageEditMode){
      this.infoEditor.disableReadOnlyMode('editor');
    } 
  }

  initializeEditor(model) {
    setTimeout(() => {
    if(this.editorAdditionalInfo && model === 'info') {
      this.editorAdditionalInfo.editorInstance.setData(this.pageData.additionalInfo)
    }
    if(this.editorDescription && model === 'desc'){
      this.editorDescription.editorInstance.setData(this.pageData.description)
    }
   }, 200);
  }

  ckchanges(ev, label, model) {
    if (label === 'ready') {
      const clipboardPlugin = ev.plugins.get('ClipboardPipeline');
      const editingView = ev.editing.view;
      editingView.document.on('clipboardInput', (evt, data) => {
        if (ev.isReadOnly) {
          return;
        }
        const dataTransfer = data.dataTransfer;
        const plaintext = dataTransfer.getData('text/plain');
        const htmltext = dataTransfer.getData('text/html');
        const text = this.htmlToPlainTextExcludingPara(plaintext);
        data.content = ev.data.htmlProcessor.toView( text );
      });
      switch (model) {
        case 'desc':
          this.descriptionEditor = ev;
          break;
        case 'info':
          this.infoEditor = ev;
          break;
        default: break;
      }
      this.initializeEditor(model)
    }
    if (label === 'focus') {
      switch (model) {
        case 'info':
          this.infoFocusFlag = true;
          break;
        case 'desc':
          this.descriptionFocusFlag = true;
          break;
        default: break;
      }
    }
    if (label === 'blur') {
      switch (model) {
        case 'info':
          this.infoFocusFlag = false;
          break;
        case 'desc':
          this.descriptionFocusFlag = false;
          break;
        default: break;
      }
    }
    if (label === 'change') {
      if(model==='info'){
        this.checkingHyperlinkValid(this.infoEditor,model,this.pageData.additionalInfo)
      }
      if(model==='desc'){
        this.checkingHyperlinkValid(this.descriptionEditor,model,this.pageData.description)
      }
    }
    this.ckEditorReadOnlyDisabled();
  }

  checkingHyperlinkValid(editor,type,data) {
    if(editor && editor.model) {
      const doc = editor.model.document;
      const selection = doc.selection;
      const range = selection.getFirstRange();
      let selectedWord;
      for (const item of range.getItems()) {
        selectedWord = item.data;
    }
      let docStr = (JSON.stringify(doc));
      if(JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeKey'] === 'linkHref'){
        let hrefUrl =this.sharedService.extractHrefUrl(editor);
          if(hrefUrl !== undefined && hrefUrl !== null) {
            let allLink =  this.sharedService.findInvalidLinkWord(editor);
            let matchLinkObj = allLink.filter(e =>e.href===hrefUrl)
            const validLink = this.checkUrlValidate(hrefUrl,data,type,editor);
            if(validLink){
              this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url='+hrefUrl)
              .subscribe((response) => {
              if(response.statusCode === 200){
              } else {
              setTimeout(e4 => {
                if(editor) {
                  this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
                }
              }, 1000); 
              this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            }
          },error=>{
            setTimeout(e4 => {
              if(editor) {
                this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
              }
            }, 1000); 
            this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            })
          
          }
          }
      }
    }
     else {
      return true;
    }
  }

  checkUrlValidate(url,data,type,editor) {
    var urlValid = /[a-z0-9-]*\.?[a-z0-9-]+\.[a-z0-9-]+\.?[a-z0-9-]+(\/[^<>]*)?$/;
    let allLink =  this.sharedService.findInvalidLinkWord(editor);
    let matchLinkObj = allLink.filter(e =>e.href===url)
    if(urlValid.test(url) === false) {
       this.snotify.info('Please enter valid URL', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);
     } else if(!url.startsWith('https')) {
       this.snotify.error('Link is invalid,link should be start with https.Please enter valid link.', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);    
     }
     return urlValid.test(url) && url.startsWith('https') ;
  }

  getremoveInvalidLink(cardData,word,type,editor){
    let paraBody=cardData;
      if(!!word && !!cardData){
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          cardData= paraBody;
          editor ? editor.setData(cardData):'';
        }
      }
  }

  htmlToPlainTextExcludingPara(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(text);
    } else {
      return text;
    }
  }
  htmlSpecialCharToText(text) {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
      'nbsp': ' ',
      'amp': '&',
      'quot': '\'',
      'lt': '<',
      'gt': '>'
    };
    return (text.replace(translate_re,
      (match, entity) => {
        return translate[entity];
      })
    );
  }

  ngOnInit() {
    this.todayDate = moment().format("YYYY-MM-DD");
    if (this.id && this.id.indexOf('?domain') > -1) {
      this.id = this.id.substring(0, this.id.indexOf('?domain'));
    }
    this.getPageMetaList();
    const conf = localStorage.getItem(StaticDataService.domainsConfigLiteral);
    const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    if (conf && domain) {
      this.domainConfig = JSON.parse(conf)[domain];
    } else {
      this.domainConfig = StaticDataService.defaultConfig;
    }
    this.sharedService.setTitle('page managment');
    this.subscriptions.push(
      this.sharedService.getData().subscribe(x => {
        if (x === 'pagePublish') {
          this.savePage(true);
        }
      }));
    if (this.id !== null) {
      this.lockAcquire(this.id, flag => {
        console.log(`inside acquire log  id ${this.id} flag ${flag}`)
        if (flag && !(this.accessType=='View')) {
          console.log(`insideflag true ${this.id} flag ${flag}`)
          this.initPageView(this.id, false);
          this.pageEditMode = true;
          this.publishFlag = false;
        } else {
          console.log(`insideflag else ${this.id} flag ${flag}`)
          this.initPageView(this.id, true);
          this.pageLoaded = false;
          this.changeFlag = false;
          this.pageEditMode = false;
        }
      });
    } else {
      this.loadJqueryViewMethods();
      this.pageLoaded = true;
    }
    this.getDesignList();
    this.getTemplateList();
    this.getComponentDesignList();
    this.sharedService.sendData('storyEditor|true');
    this.sponsorImageFlag = this.sharedService.isdomainConfig('pages','sponsorImage');
    if(sessionStorage.getItem(StaticDataService.domainLiteral) === '5df8a1b2e75f583b86696dbb') {
      this.restService.http_get(
        this.config.get('product').baseUrl + '/api/cms/story/productcategories'
          ).subscribe(res => {
           res.map((category)=> {
            this.autocompletelist.push(category.categoryName);
           })
          });
      console.log("TECH")
    } else {
      this.autocompletelist = ['car','bike'];
      console.log("OTHER")
    }
  }
  ngDoCheck() {

    const localtempvar = this.pageData;
    if (localtempvar) {
      delete localtempvar['createdDate'];
      delete localtempvar['lastModifiedDate'];
     // delete localtempvar['lastPublishedDate'];
    }
    const cochange = this.getDifference(this.lastPageData ? this.lastPageData : '', localtempvar ? JSON.stringify(localtempvar) : '');
    if (this.pageLoaded && cochange !== '') {
      if (localtempvar) {
        this.lastPageData = JSON.stringify(localtempvar);
      }
      if (this.firstLoadCheck > 0) {
        this.changeFlag = true;
        this.sharedService.sendData('saved|true');
      }
      this.firstLoadCheck++;
    }
    if (this.pageData && this.pageEditMode) {
      this.sendPublishDisableCommand(false);
    } else {
      this.sendPublishDisableCommand(true);
    }
  }

  sendPublishDisableCommand(flag) {
    if (flag) {
        this.sharedService.sendData('publish_disable|true');
      } else {
        this.sharedService.sendData('publish_disable|false');
      }
   
  }

  openPreview(platform) {
    let prviewUrl=this.config.get('product').previewUrl;
    if(this.domainConfig['config'] && this.domainConfig['config']['previewUrl'] && this.domainConfig['config']['previewUrl']['url']) {
      prviewUrl = this.domainConfig['config']['previewUrl']['url'];
    }
    if(prviewUrl=="") return this.snotify.error("Don't have a permission",'', this.sharedService.getConfig(false))
    const url = prviewUrl + '/preview/page/' + this.pageData.id;
    if (this.pageData.id !== null) {

      this.iframeStyle = this.sanitizer.bypassSecurityTrustStyle((platform === 'mobile')
        ? 'width:425px;height:96vh;border:none;position:relative;z-index:21;'
        : 'width:100%;height:96vh;border:none;position:relative;z-index:21;');
      this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.previewPlatform = platform;
      this.previewPopup = true;
      this.sharedService.overflowhidden();
    }
  }

  iframeLoaded(ev) {
    // console.log('callesd', ev);
    console.log('end', new Date());
    this.iframeLoading += 1;
  }
  closePreview() {
    this.previewUrl = null;
    this.previewPlatform = null;
    this.previewPopup = false;
    this.iframeLoading = 0;
    this.sharedService.overflowauto();
  }

  makeRenderable(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
  getDifference(a, b) {
    let i = 0;
    let j = 0;
    let result = '';
    while (j < b.length) {
      if (a[i] !== b[j] || i === a.length) {
        result += b[j];
      } else {
        i++;
      }
      j++;
    }
    return result;
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;
    if (this.secondaryCTA && !this.secondaryCTA.nativeElement.contains(clickedComponent)) {
      this.revertListFlag = false;
    }
    if (this.columnField && this.columnField['_results'][0] && clickedComponent === this.columnField['_results'][0].nativeElement) {
      this.insideColumn = true;
      if (this.columnQuery === '') {
        this.filteredColumnSuggestion = this.columnSuggestion;
      }
    }
    else if (this.sectionField && this.sectionField['_results'][0] && clickedComponent === this.sectionField['_results'][0].nativeElement) {
      this.insideSection = true;
      this.insideSubSection = false;
      if (this.sectionQuery === '') {
        this.filteredSectionSuggestion = this.sectionSuggestion;
      }
    }
    else if (this.subSectionField && this.subSectionField['_results'][0] && clickedComponent === this.subSectionField['_results'][0].nativeElement) {
      this.insideSubSection = true;
      this.insideSection = false;
      if (this.subSectionQuery === '') {
        if (this.pageData.metadata.section !== null && this.pageData.metadata.section !== '') {
          this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.pageData.metadata.section];
        } else {
          this.filteredSubSectionSuggestion = [];
        }
      }
    } else {
      this.insideColumn = false;
      this.filteredColumnSuggestion =  [];
      this.insideSection = false;
      this.insideSubSection = false;
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
    }
    this.currentSelection = 0;
  }

  canDeactivate() {
    if (this.changeFlag && !(this.accessType=='View')) {
      const x = window.confirm('Discard changes?');
      if (!x) {
        this.loadJqueryViewMethods();
        return false;
      } else {
        if (this.pageData.id === null) {
          return true;
        } else {
          this.lockRelease(this.pageData.id, data => {
            console.log(data ? 'lock released of id=> ' + this.pageData.id : 'lock not released');
            return data;
          });
          return true;
        }
      }
    } else {
      if (this.pageData && this.pageData.id === null) {
        return true;
      } else {
        if (this.pageData) {
          this.lockRelease(this.pageData.id, data => {
            console.log(data ? 'lock released of id=> ' + this.pageData.id : 'lock not released');
            return data;
          });
          return true;
        }
      }
    }
  }

  @HostListener('window:resize') onResize() {
    // guard against resize before view is rendered
    this.loadJqueryViewMethods();
  }

  loadJqueryViewMethods() {
    console.log('called loadJqueryViewMethods')
    if (this.pageLoaded) {
      console.log('this.pageLoaded',this.pageLoaded)
      this.generatePageAutoSaveInterval();
      this.sharedService.overflowauto();
    }
  }

  setType(type, ev) {
    if(ev[0]) {
      this.pageData[type] = ev[0];
    } else {
      this.pageData[type] = null;
    }
    
    console.log(this.pageData[type])
  }

  initPageView(id, option) {
    this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
      + '/' + id)
      .subscribe(
        data => {
          this.sharedService.sendData('saved|false');
          if(this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['socket'] && this.domainConfig['config']['socket']['enableSocket'] && this.domainConfig['config']['socket']['enableSocket'] === 'true')
          {
            this.initiateSocket(data.id);
          }
          this.pageData = data;
          this.sharedService.domainIdSubject.next(data.domainId);
          this.pageLoaded = true;
          this.pageQuery = data.design;
          if(this.pageData.metadata.section) {
            this.sectionQuery = this.pageData.metadata.section;
          }
          if(this.pageData.metadata.subSection) {
            this.subSectionQuery = this.pageData.metadata.subSection;
          }
          this.loadJqueryViewMethods();
          this.pageData.lastPublishedDate = data.lastPublishedDate;
          if (data.design === 'template') {
            this.checkForAllCollections(data.template);
            let type = JSON.parse(JSON.stringify(data.template));
            delete type['grids'];
            this.templateType = type;
          }
          if (!this.pageData.hasOwnProperty('additionalInfo') || !this.pageData.additionalInfo) {
            this.pageData.additionalInfo = '';
          }
          if (!data.metadata.dynamicMeta && this.newMetas) {
            for (let i = 0; i < this.newMetas.length; i++) {
              if (this.newMetas[i].pageType.indexOf(data.pageType.toLowerCase()) > -1 && this.newMetas[i].active) {
                this.saveDynamicMetaValue({key: "AMP", value: "true"}, 'AMP');
              }
            }
          }
          const listIdArray = [];
          this.pushPinnedArticles = [];
          this.pushPinnedArticles = data.pinnedArticles;
          if (this.pushPinnedArticles) {
            for (let i = 0; i < this.pushPinnedArticles.length; i++) {
              if (this.pushPinnedArticles[i] !== null && this.pushPinnedArticles[i].article !== null) {
                listIdArray.push(this.pushPinnedArticles[i].article.id);
              }
            }
          }
          this.mergeArray = listIdArray + ',' + data.pageArticles;
          const historyStr = this.pageData.modificationHistory;
          // if(this.pageData.createdBy) {
          //   console.log("CREATED BY", this.pageData.createdBy )
          //   this.listOfHistoryArray.push({
          //     'historyDate': this.pageData.creationDate, 'name': this.pageData.createdBy
          //   });
          // }
          for (const key in historyStr) {
            if (key) {
              this.listOfHistoryArray.push({
                'historyDate': key, 'name': historyStr[key]
              }
              );
            }
          }
          this.viewPortItems = Object.assign([], data['bodyElements']);
          this.currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
          const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[this.currentDomain].role;
          if (option && role && (role === 'ROLE_ADMIN' || role === 'ROLE_EDITOR' || role === 'ROLE_SUPER_ADMIN' || role==='ROLE_SITE_MANAGER') && !(this.accessType=='View')) {
            const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock'); // Omit props what i don't need
            this.snotify.confirm('Locked by ' + data.lockedByUserName + ', Unlock?', '', {
              ...config,
              buttons: [
                {
                  text: 'Yes', action: (toast) => {
                    this.snotify.remove(toast.id);
                    this.unlockPagepush(id, flag => {
                      if (flag) {
                        this.lockAcquire(id, flag2 => {
                          if (flag2) {
                            this.initPageView(id, false);
                            this.pageEditMode = true;
                          }
                        });
                      } else {
                        this.changeFlag = false;
                        this.pageEditMode = false;
                      }
                    });
                    this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
                  }, bold: false
                },
                { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
                  this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
                } }
              ]
            });
          }

        },
        error => {
          if (error.status !== 401) {
            setTimeout(e => {
              this.snotify.error('Page Id doesn\'t exist', '', this.sharedService.getConfig(false));
            }, 10);
            this.ngZone.run(() => {
              this.router.navigate(['/dash/pages/']);
            });
          } else {
            this.ngZone.run(() => {
              this.router.navigate(['/login']);
            });
          }
        }
      );
  }
  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }
  generatePageAutoSaveInterval() {
    console.log('called generatePageAutoSaveInterval')
    if (this.autosave === null) {
      console.log('this.autosave null check')
      this.autosave = setInterval(() => {
        this.savePage(false);
      }, 1500);
    }
  }
  destroyPageAutoSaveInterval() {
    if (this.autosave !== null) {
      clearInterval(this.autosave);
      this.autosave = null;
    }
  }
  ngOnDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
    if (this.isLocked && this.pageData !== null && this.pageData.id !== null) {
      this.releaselocknow(this.pageData.id);
    }
    this.destroyViewComponents();
    this.destroyPageAutoSaveInterval();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.snotify.clear();
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  getComponentDesignList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/element/design/all/collection')
      .subscribe(
        data => {
          this.componentDesigns = data;
        },
        err => {
          console.log(err);
        }
      );
  }

  removePtags(st) {
    return st.replace(/<p>/g, '').replace(/<\/p>/g, '');
  }

  savePage(publishFlag) {
    console.log('called savePage with flag',publishFlag)
    if (this.isLocked) {
      this.publishFlag = publishFlag;
      if (publishFlag) {
        this.changeFlag = true;
      }
      if (publishFlag ? true : (this.changeFlag && this.saveInQueue === 0)) {
        this.saveInQueue += 1;

        if (publishFlag || this.pageData.status === 'PUBLISHED') {
          this.pageData.status = 'PUBLISHED';
          //this.pageData.lastPublishedDate = data.lastPublishedDate;
        }
        if (this.pageData.design === null || this.pageData.design === '') {
          this.pageData.design = 'list';
        }
       // this.pageData.description = this.removePtags(this.pageData.description);
        this.restService.http_put(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
          + String(this.id) + (publishFlag ? '' : '?autoSave=true'),
          this.sharedService.checkhrefandreplace(this.pageData),
          result => {
            console.log('savePage respnse',result)
            this.saveInQueue -= 1;
            if (result.status === 409) {
              this.snotify.error('Page already present', '', this.sharedService.getConfig(false));
              this.changeFlag = false;
            } else {
              this.changeFlag = false;
              this.pushPinnedArticles = [];
              this.pushPinnedArticles = result.pinnedArticles;
              const listIdArray = [];
              this.pageQuery = result.design;
              // if (result.design === 'list') {
              //   this.Category = 'story';
              // }
              if (this.pageData !== null) {
                this.pageData['lastModifiedDate'] = result['lastModifiedDate'];
                this.pageData['lastPublishedDate'] = result['lastPublishedDate'];
                this.pageData['lastModifiedBy'] = result['lastModifiedBy'];
                this.pageData['lastPublishedBy'] = result['lastPublishedBy'];
                this.pageData['lastModifiedByUserName'] = result['lastModifiedByUserName'];
                this.pageData['lastModifiedBy'] = result['lastModifiedBy'];
                this.pageData['firstPublishedDate'] = result['firstPublishedDate'];
              }

              if (this.pushPinnedArticles != null) {
                for (let i = 0; i < this.pushPinnedArticles.length; i++) {
                  if (this.pushPinnedArticles[i] !== null) {
                    listIdArray.push(this.pushPinnedArticles[i].article.id);
                  }
                }
              }
              const historyStr = result.modificationHistory;
              this.listOfHistoryArray = [];
              for (const key in historyStr) {
                if (key) {
                  this.listOfHistoryArray.push({
                    'historyDate': key, 'name': historyStr[key]
                  }
                  );
                }
              }
              this.mergeArray = listIdArray + ',' + result.pageArticles;
              if (publishFlag) {
                this.snotify.success('Updated and published successfully', '', this.sharedService.getConfig(false));
                this.publishFlag = false;
                // this.snotify.clear();
              }
              this.sharedService.sendData('saved|false');
              console.log('completed savePage method')
            }
          });
      }
    }
  }
  deleteImage(type){
    if(type === 'cover') {
      this.pageData.coverImage = null;
    }
  }

  onFileChange(event,imageType) {
    this.imageType=imageType;
    const reader: FileReader = new FileReader();
    this.selectedFile = <File>event.target.files[0];
    if (event.target.files && event.target.files.length > 0) {
      if ((typeof event.target.files[0]) === 'object') {
        if ((this.selectedFile.size / 1000000) <= 11) {
          const a = reader.readAsDataURL(event.target.files[0]);
          reader.onload = (e: any) => {
            this.openCropper(e.target.result);
          };
        } else {
          this.selectedFile = null;
          this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
      }
    }
    this.sharedService.overflowhidden();
  }

  openCropper(data) {
    this.pickStoryImageLoad = true;
    const fd = new FormData();
    fd.set('file', this.selectedFile, this.selectedFile.name);
    fd.set('removeLowQualityRestriction','true');
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
      subscribe(res => {
        this.cropperImageUrl.url = res['images']['original'];
        this.cropperImageUrl.data = data;
        this.showCropper = true;
      },
        err => {
          this.snotify.clear();
          this.snotify.error(err.error.errorMessage, '', this.sharedService.getConfig(false));
          this.pickStoryImageLoad = false;
        });
  }

  cancelCropping() {
    this.showCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null
    };
    this.imageType = "";
    this.selectedFile = null;
    this.pickStoryImageLoad = false;
  }

  finishCropping(event,imageType) {
    const requests = event.cropRequests;
    this.cancelCropping();
    this.croppingInProgress = true;
    this.sharedService.croppingSequence(requests, false, data => {
      this.croppingInProgress = false;
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        if(imageType === 'coverImage'){
          if(this.pageData.pageType === 'BRUNCH'){
            this.pageData.coverImage = JSON.stringify(imagemap['original'] || '').replace(/"/gi, '');
          }
          else{
        this.pageData.coverImage = JSON.stringify(imagemap['960x540'] || '').replace(/"/gi, '');
          }
        this.pageData.images = imagemap;
        }
        if(imageType === 'sponsorImage'){
          this.pageData.sponsorImage = JSON.stringify(imagemap['960x540'] || '').replace(/"/gi, '');
        }
      } else {
        console.log(data);
      }
    });
    this.imageType='';

  }

  toggleSwitch(type){
    if(type === 'revenueSpecial'){
      this.pageData.metadata.revenueSpecial = !this.pageData.metadata.revenueSpecial;
    }
    if(type === 'autobacklink'){
      this.pageData.toBeAutobacklink = !this.pageData.toBeAutobacklink;
    }
    if(type === 'propernoun'){
      this.pageData.properNoun = !this.pageData.properNoun;
    }
    if(type === 'noFollow'){
      this.pageData.noFollow = !this.pageData.noFollow;
    }
  }
  getListIdToParentfn(obj) {
    if (obj === true) {
      this.showlockBg = true;
    } else {
      if (obj.length > 1) {
        this.pageData.pinnedArticles = [];
        this.pageData.pinnedArticles = obj;
        this.changeFlag = true;
        this.savePage(false);
      } else {
        if (obj.article.id != null) {
          if (!this.pageData.pinnedArticles) {
            this.pageData.pinnedArticles = [];
          }
          let flag = false;
          this.publishFlag = false;
          for (const index in this.pageData.pinnedArticles) {
            if (index) {
              const pageList = this.pageData.pinnedArticles[index];
              if (pageList.article != null) {
                if (pageList.article.id === obj.article.id) {
                  if (obj.expireAt == null && !obj.positionChange) {
                    this.pageData.pinnedArticles.splice(index, 1);
                    this.changeFlag = true;
                  } else {
                    obj = {
                      expireAt: obj.expireAt,
                      position: obj.position,
                      article: {
                        id: obj.article.id
                      }
                    }
                    this.pageData.pinnedArticles[index] = obj;
                    this.changeFlag = true;
                  }
                  flag = true;
                  break;
                }
              }
            }
          }
          if (!flag) {
            this.pageData.pinnedArticles.push(obj);
            this.changeFlag = true;
          } else {
            if (this.pageData.pageArticles.indexOf(obj.article.id) < 0) {
              this.pageData.pageArticles.splice(0, 0, obj.article.id);
              this.changeFlag = true;
            }
          }
          this.savePage(false);
          this.showlockBg = false;
        }
      }
    }
  }

  initiateSocket(id) {
    const ws = new SockJS(this.serverUrl
      + '?access_token='
      + JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).access_token);
    this.stompClient = Stomp.over(ws);
    this.stompClient.debug = false;
    const self = this;
    const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.stompClient.connect({}, function (frame) {
      console.log('page ' + id + ' socket online!');
      self.stompClient.subscribe('/topic/zone-lock-' + domain, (message) => {
        // console.log(JSON.parse(message.body));
        const body = JSON.parse(message.body);
        if (self.pageEditMode && body.lockedByUserId) {
          if (self.pageData && (+self.id === body.zoneId) && (self.pageData.lockedByUserId !== body.lockedByUserId)) {
            self.pageEditMode = false;
            self.destroyPageAutoSaveInterval();
            self.changeFlag = false;
            self.snotify.warning('Page has now been locked by ' + body.lockedByUserName,
              '', self.sharedService.getConfig(false));
          }
        }
      },
        err => {
          console.log('sorry could not subscribe to socket');
        });
    });
  }
  lockAcquire(story_id, callback) {
    if (this.isLocked === false && this.accessType!='View') {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
        + '?pageId='
        + String(story_id)
      ).subscribe(
        data => {
          console.log('acquired => ' + data);
          this.isLocked = true;
          callback(data);
        },
        error => {
          console.log('lock not acquired');
          callback(false);
        });
    } else {
      console.log('lock already acquired');
      callback(true);
    }
  }

  lockRelease(story_id, callback) {
    if (this.isLocked === true) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
        + '?pageId='
        + String(story_id)
      )
        .subscribe(
          data => {
            console.log('released => ' + data);
            this.isLocked = false;
            callback(data);
          },
          error => {
            console.log(error);
            callback(false);
          });

    } else {
      console.log('lock already released');
      callback(true);
    }
  }
  releaselocknow(id) {
    // const token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
    // const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    // const auth = `Bearer ` + token.access_token;
    // const url = this.config.get('product').baseUrl
    //   + '/page/lock/release'
    //   + '?Authorization=' + auth
    //   + '&Domain=' + domain
    //   + '&pageId='
    //   + String(id);
    // $.ajax({
    //   url: url,
    //   crossDomain: true,
    //   type: 'GET',
    //   success: () => {
    //     this.isLocked = false;
    //   }
    // });
     this.lockRelease(id, data => {
      return data;
    });
  }
  @HostListener('window:unload', ['$event'])
  public onunload(event) {
    if (this.isLocked && this.pageData !== null && this.pageData.id !== null) {
      this.releaselocknow(this.pageData.id);
    }
  }
  @HostListener('window:keydown', ['$event'])
  public hotkeys($event) {
    const key = $event.keyCode || $event.charCode;
    const a = this.descriptionFocusFlag ? this.descriptionElement.nativeElement.getElementsByClassName('ck-off')
      : (this.infoFocusFlag ? this.infoElement.nativeElement.getElementsByClassName('ck-off') : []);
    if (key === 72 && $event.ctrlKey && $event.shiftKey
      || $event.metaKey && key === 72 && $event.shiftKey) {
      console.log('hyperlink');
      $event.preventDefault();
      if (a.length > 0) {
        a[0].click();
      }
      $event.stopPropagation();
    }

    if (key === 83 && $event.ctrlKey
      || $event.metaKey && key === 83) {
      event.preventDefault();
      this.savePage(false);
    }
    if (key === 27) {
      if (this.showCropper) {
        this.cancelCropping();
      }
      if (this.previewPopup) {
        this.closePreview();
      }
      if (this.revertListFlag) {
        this.revertListFlag = false;
      }
      if (this.deleteLineupPopup) {
        this.closeLineupPopup();
      }
      if (this.insideColumn) {
        this.insideColumn = false;
      }
      if (this.insideSection) {
        this.insideSection = false;
      }
      if (this.insideSubSection) {
        this.insideSubSection = false;
      }
    }
    if(key === 40 && !$event.shiftKey){
       this.innerFocusFlag = true;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  public confirmUnload($event) {
    this.snotify.clear();
    this.overrideSave();
    if (this.pageData && this.pageData.id !== null && this.changeFlag) {
      const message = 'Changes are not saved, are you sure you want to leave?';
      if (typeof $event === 'undefined') {
        $event = window.event;
      }
      if ($event) {
        $event.returnValue = message;
      }
      return message;
    } else {
      return true;
    }
  }
  destroyViewComponents() {
    this.destroyPageAutoSaveInterval();
  }
  overrideSave() {
    this.destroyPageAutoSaveInterval();
    setTimeout(e => {
      this.savePage(false);
      setTimeout(e2 => {
        this.generatePageAutoSaveInterval();
      }, 200);
    }, 200);
  }
  unlockPage() {
    this.ckEditorReadOnlyDisabled()
    this.currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[this.currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN' && role !== 'ROLE_EDITOR' && role!=='ROLE_SITE_MANAGER') {
      this.snotify.error('You don’t have permission to unlock a story', '', this.sharedService.getConfig(false));
    } else {
      this.unlockPagepush(this.id, flag => {
        if (flag) {
          this.isLocked = false;
          this.lockAcquire(this.id, flag2 => {
            if (flag2) {

              this.initPageView(this.id, false);
              this.pageEditMode = true;
            } else {
              console.log('lock not acquired');
            }
          });
        } else {
          console.log('lock not acquired');
          this.changeFlag = false;
          this.pageEditMode = false;
        }
      });
      this.snotify.clear();
    }
  }
  unlockPagepush(page_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.unLockPage)
      + '?pageId='
      + String(page_id)
    )
      .subscribe(
        data => {
          console.log('acquired => ' + data);
          this.destroyViewComponents();
          callback(data);
        },
        error => {
          console.log(error);
          console.log('lock not acquired');
          callback(false);
        });
  }
  getVersionDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      const milliseconds = date.getTime();
      const res =
        (this.monthNames[date.getMonth()])
        + ' '
        + (date.getDate())
        + ', '
        + (date.getFullYear())
        + ' ['
        + ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()
          + ']'
        );
      return res;
    } else {
      return 'not present';
    }
  }
  getArticleIdToParentfn(obj) {
    if (!this.pageData.pageArticles) {
      this.pageData.pageArticles = [];
    }
    let flag = false;
    this.publishFlag = false;
    for (const index in this.pageData.pageArticles) {
      if (index) {
        const i = index;
        const pageList = this.pageData.pageArticles[i];
        if (pageList === obj) {
          this.pageData.pageArticles[i] = obj;
          flag = true;
          break;
        }
      }
    }
    if (!flag) {
      this.pageData.pageArticles = [];
      this.pageData.pageArticles = obj;

    }
    this.changeFlag = true;
    this.savePage(false);
  }

  checkForAllCollections(ev) {
    if (ev.elements && ev.elements !== null) {
      this.allCollections = this.allCollections.concat(ev.elements);
      if (ev.elementProperties !== null) {
        Object.keys(ev.elementProperties).forEach(id => {
          this.allCollectionsMeta[id] = ev.elementProperties[id];
        });
      }
    }
    if (ev.grids && ev.grids.length > 0) {
      for (let grid of ev.grids) {
        this.checkForAllCollections(grid);
      }
    }
  }

  getZoneData(ev) {
    this.recursiveUpdation(this.pageData.template, ev);
    setTimeout(e => {
      // console.log(this.pageData.template);
      this.allCollections = [];
      this.allCollectionsMeta = {};
      this.checkForAllCollections(this.pageData.template);
      setTimeout(e4 => {
        console.log(this.allCollections, this.allCollectionsMeta);
      }, 100);
    }, 100);
  }

  recursiveUpdation(full, check) {
    if (full.id === check.id) {
      full.elements = check.elements;
      full.elementProperties = check.elementProperties;
    } else {
      if (full.grids && full.grids.length > 0) {
        for (let grid of full.grids) {
          this.recursiveUpdation(grid, check);
        }
      }
    }
  }

  setStoryHeight() {
    const intViewportHeight = window.innerHeight - 140;
    const styles = {
      'min-height': + intViewportHeight + 'px'
    };
    return styles;
  }
  getDesignList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/design/all')
      .subscribe(
        data => {
          this.pageDataInsertion(data);
        },
        err => {
          console.log(err);
        }
      );
  }
  getTemplateList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/meta')
      .subscribe(
        data => {
          this.templateTypes = data['templates'];
        },
        err => {
          console.log(err);
        }
      );
  }

  changeTemplateDesign(selection) {
    // console.log(selection);
    if ((this.pageData.design === 'template') && (this.pageData.template.id !== selection.id)) {
      if (this.allCollections.length > 0) {
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock'); // Omit props what i don't need
        this.snotify.confirm('All saved data will be erased, Do you want to change the template design?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
                this.snotify.remove(toast.id);
                this.setTemplateDesign(selection.id);
              }, bold: false
            },
            { text: 'No', action: (toast) => { this.snotify.remove(toast.id); } }
          ]
        });
      } else {
        this.setTemplateDesign(selection.id);
      }
    }
  }

  setTemplateDesign(templateId) {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/template/' + templateId)
      .subscribe(
        data => {
          this.pageData.template = null;
          this.pageData.template = data;
          this.allCollections = [];
          this.allCollectionsMeta = {};
          this.checkForAllCollections(this.pageData.template);
        },
        err => {
          console.log(err);
        });
  }

  selectAutoCompletePage(item) {
    this.pageQuery = item.value;
    this.pageData.design = item.value;
    this.filteredpageDesign = [];
  }
  pageDataInsertion(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== null) {
        this.pageDesign.push({ 'value': data[i] });
      }
    }
  }
  filterAutoComplete() {
    this.filteredpageDesign = this.pageDesign;
    // console.log(this.pageDesign);
  }

  _compareFn(a, b) {
    return a && b ? a.id === b.id : a === b;
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  zoneDrop(ev) {
    // ev.preventDefault();
    // let start = ev.dataTransfer.getData('text');
    const start = this.sharedService.dragValue;
    this.sharedService.dragValue = null;
    const end = ev.target.id;
    if (start && end && (start.indexOf('|') > -1)) {
      if (end.indexOf('|') > -1) {
        const a = start.split('|');
        const b = end.split('|');
        if (a[0] === b[0]) {
          this.sameZoneSwap(this.pageData.template, a[0], Number(a[1]), Number(b[1]));
        } else {
          this.addRecursively(this.pageData.template, b[0], Number(a[1]), Number(b[1]), remove => {
            if (remove) {
              this.removeRecursively(this.pageData.template, a[0], Number(a[1]));
            }
          });
        }
      } else {
        const a = start.split('|');
        console.log(a, end);
        if (a[0] === end) {
          this.sameZoneSwap(this.pageData.template, a[0], Number(a[1]), null);
        } else {
          this.addRecursively(this.pageData.template, end, Number(a[1]), null, remove => {
            if (remove) {
              this.removeRecursively(this.pageData.template, a[0], Number(a[1]));
            }
          });
        }
      }
    }
  }

  sameZoneSwap(all, zone, id1, id2) {
    if (all.id === zone) {
      const startindex = all.elements.indexOf(id1);
      const endindex = all.elements.indexOf(id2);
      if (id2 !== null && startindex > -1 && endindex > -1) {
        all.elements.splice(startindex, 1);
        setTimeout(e => {
          const endindex2 = all.elements.indexOf(id2);
          all.elements.splice(endindex2, 0, id1);
        }, 20);
      } else if (id2 === null && startindex > -1) {
        all.elements.splice(startindex, 1);
        setTimeout(e => {
          all.elements.push(id1);
        }, 20);
      }
    } else {
      if (all.grids && all.grids.length > 0) {
        for (let grid of all.grids) {
          this.sameZoneSwap(grid, zone, id1, id2);
        }
      }
    }
  }

  addRecursively(all, zone, id, id2, callback) {
    if (all.id === zone) {
      if (all.limit > all.elements.length) {
        if (id2 && id2 !== null && (all.elements.indexOf(id2) > -1)) {
          all.elements.splice(all.elements.indexOf(id2), 0, id);
        } else {
          all.elements.push(id);
        }
        if (this.allCollectionsMeta.hasOwnProperty(id)) {
          all.elementProperties[id] = JSON.parse(JSON.stringify(this.allCollectionsMeta[id]));
        }
        callback(true);
      } else {
        // console.log('max limit reached');
        this.snotify.warning('Max limit of collections reached', '', this.sharedService.getConfig(false));
        callback(false);
      }
    } else {
      if (all.grids && all.grids.length > 0) {
        for (let grid of all.grids) {
          this.addRecursively(grid, zone, id, id2, callback);
        }
      }
    }
  }

  removeRecursively(all, zone, id) {
    if (all.id === zone) {
      if (all.elements.indexOf(id) > -1) {
        all.elements.splice(all.elements.indexOf(id), 1);
        if (this.allCollectionsMeta.hasOwnProperty(id)) {
          delete all.elementProperties[id];
        }
      }
    } else {
      if (all.grids && all.grids.length > 0) {
        for (let grid of all.grids) {
          this.removeRecursively(grid, zone, id);
        }
      }
    }
  }
  purgePage() {
    this.restService.http_post(this.config.get('product').purgeUrl + '/api/cms/page/purge/' + this.pageData.id,
      null, result => {
        if (!result || !result.hasOwnProperty('error')) {
          this.revertListFlag = false;
          this.snotify.success('Purge request accepted', '', this.sharedService.getConfig(false));
        } else {
          this.snotify.error('Page could not be purged', '', this.sharedService.getConfig(false));
        }
      });
  }

  isCardViewEnabled(type) {
    if (type == 'card') { return  this.sharedService.isdomainConfig('subSection','cardView');
     } else if (type == 'elements') { return  this.sharedService.isdomainConfig('subSection','showElementList'); }
  }
  clearPageLineup() {
    this.pageData.pageArticles = [];
    this.pageData.pinnedArticles = [];
    if (this.lineupElement) {
      this.lineupElement.cleanLineup();
    }
    this.changeFlag = true;
    this.savePage(false);
    this.snotify.success('Page Line-up Cleared', '', this.sharedService.getConfig(false));
    this.closeLineupPopup();
  }
  openLineupPopup() { this.deleteLineupPopup = true; }
  closeLineupPopup() { this.deleteLineupPopup = false; }
  disableInnerFocus(ev) { this.innerFocusFlag = false; }
  catchTagFocus(event){}
  getValuefromThis(s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    let o = this;
    const a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in o) {
        if (o[k] !== null) {
          o = o[k];
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
    if (o) {
      return o;
    } else {
      return null;
    }
  }
  filterAutoCompleteUp(event, model) {
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
       if (model === 'column') {
        if (this.insideColumn) {
          if (this.columnQuery.length > 0) {
            this.filteredColumnSuggestion = this.columnSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.columnQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.pageData.metadata.column = '';
            this.columnQuery = '';
            this.filteredColumnSuggestion = this.columnSuggestion;
          }
        } else {
          this.insideColumn = true;
          this.filteredColumnSuggestion = [];
        }
        }
        if (model === 'section') {
          if (this.insideSection) {
            if (this.sectionQuery.length > 0) {
              this.filteredSectionSuggestion = this.filteredSectionSuggestion.filter(function (el) {
                return el.toLowerCase().indexOf(this.sectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.pageData.metadata.section = '';
              this.sectionQuery = '';
              this.filteredSectionSuggestion = this.sectionSuggestion;
            }
          } else {
            this.insideSection = true;
            this.filteredSectionSuggestion = [];
          }
        }
        if (model === 'subSection') {
          if (this.insideSubSection) {
            if (this.sectionQuery.length > 0) {
              this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.pageData.metadata.section].filter(function (el) {
                return el.toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.pageData.metadata.subSection = '';
              this.sectionQuery = '';
              this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.pageData.metadata.section];
            }
          } else {
            this.insideSubSection = true;
            this.filteredSubSectionSuggestion = [];
          }
        }
    }
    return true;
  }

  filterAutoCompleteDown(event, model) {
    if (event.key === 'Enter') {
      if (model === 'column') {
        this.insideColumn = false;
        this.selectAutoComplete(model, this.filteredColumnSuggestion[this.currentSelection]);
      }
      if (model === 'section') {
        this.insideSection = false;
        this.selectAutoComplete(model, this.filteredSectionSuggestion[this.currentSelection]);
      }
      if (model === 'subSection') {
        this.insideSubSection = false;
        this.selectAutoComplete(model, this.filteredSubSectionSuggestion[this.currentSelection]);
      }
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'column') {
        if (this.currentSelection < (this.filteredColumnSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.columnList.nativeElement.scrollBy(0, 12);
        }
      }
      if (model === 'section') {
        if (this.currentSelection < (this.filteredSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.sectionList.nativeElement.scrollBy(0, 12);
        }
      }
      if (model === 'subSection') {
        if (this.currentSelection < (this.filteredSubSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.subSectionList.nativeElement.scrollBy(0, 12);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideColumn = false;
      this.insideSection = false;
      this.insideSubSection = false;
      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;

        if (model === 'column') {
          this.columnList.nativeElement.scrollBy(0, -12);
        }
        if (model === 'section') {
          this.sectionList.nativeElement.scrollBy(0, -12);
        }
        if (model === 'subSection') {
          this.subSectionList.nativeElement.scrollBy(0, -12);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      if ( this.insideColumn) {
        this.focusOutSuggest(model);
      }
    } else {
      this.currentSelection = 0;
    }
    return true;
  }

  focusInSuggest(model) {
    if (model === 'column') {
      this.insideColumn = true;
      if (this.columnQuery === '') {
        this.filteredColumnSuggestion = this.columnSuggestion;
      }
    }
    if (model === 'section') {
      this.insideSection = true;
      if (this.sectionQuery === '') {
        this.filteredSectionSuggestion = this.sectionSuggestion;
      }
    }
    if (model === 'subSection') {
      this.insideSubSection = true;
      if (this.subSectionQuery === '') {
        if (this.pageData.metadata.section !== null && this.pageData.metadata.section !== '') {
          this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.pageData.metadata.section];
        } else {
          this.filteredSubSectionSuggestion = [];
        }
      }
    }
    this.currentSelection = 0;
    this.lastindex = null;
    this.filterAutoCompleteUp({ keyCode: 0 }, model);
  }

  focusOutSuggest(model) {
    if (model === 'column') {
      this.insideColumn = false;
      this.filteredColumnSuggestion = [];
    }
    if (model === 'section') {
      this.insideSection = false;
      this.filteredSectionSuggestion = [];
    }
    if (model === 'subSection') {
      this.insideSubSection = false;
      this.filteredSubSectionSuggestion = [];
    }
    this.currentSelection = 0;
  }

  selectAutoComplete(model, item) {
     if (model === 'column') {
      this.columnQuery = item;
      this.pageData.metadata.column = item;
      this.filteredColumnSuggestion = [];
    }
    if (model === 'section') {
      this.sectionQuery = item;
      this.pageData.metadata.section = item;
      if (
        !(this.subSectionSuggestion.hasOwnProperty(item))
        || (this.subSectionSuggestion[item].length < 1)
        || (this.subSectionSuggestion[item].indexOf(this.pageData.metadata.subSection) < 0)) {
        this.pageData.metadata.subSection = '';
        this.subSectionQuery = '';
      }
      this.filteredSectionSuggestion = [];
    }
    if (model === 'subSection') {
      this.subSectionQuery = item;
      this.pageData.metadata.subSection = item;
      if (this.pageData.metadata.section === null || this.pageData.metadata.section === '') {
        for (const section in this.subSectionSuggestion) {
          if (section && this.subSectionSuggestion[section].indexOf(item) > -1) {
            this.pageData.metadata.section = section;
            this.sectionQuery = section;
            break;
          }
        }
      }
      this.filteredSubSectionSuggestion = [];
    }
  }

  disableElement(elementName): boolean {
    if (this.pageData) {
      if (elementName === 'meta-more') {
        if (
          this.pageData
          && this.pageData.metadata.editedBy
          && this.pageData.metadata.editedBy.length > 0
          && this.pageData.metadata.writtenBy
          && this.pageData.metadata.writtenBy.length > 0
          && this.pageData.metadata.reportedBy
          && this.pageData.metadata.reportedBy.length > 0
          && this.pageData.metadata.agencyByLine
          && this.pageData.metadata.agencyByLine.length > 0
          && this.pageData.metadata.column
          && this.pageData.metadata.column.trim() !== ''
        ) {
          return false;
        } else {
          return this.metaToggleFlag;
        }
      }
    }
  }

  getPageMetaList() {
    // let data = this.localstorageService.getSuggestionData();
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/editor/suggestions')
      .subscribe(
        data => {

          if (data.hasOwnProperty('authors')) {
            this.authorsSuggestion = data['authors'];
          }
          if (data.hasOwnProperty('columns')) {
            this.columnSuggestion = data['columns'];
          }
          if (data.hasOwnProperty('sections')) {
            // tslint:disable-next-line: forin
            for (const section in data['sections']) {
              this.subSectionSuggestion = data['sections']
              this.sectionSuggestion.push(section);
              this.allSubSections = this.allSubSections.concat(data['sections'][section]);
            }
          }
        },
        err => {
          // console.log(err);
        }
     );
  }
  getPageDynamicMetaIndex(field) {
    let dynamicMeta = { 'key': field, 'value': '' };
    if (this.pageData.metadata.dynamicMeta) {
      const exist = this.pageData.metadata.dynamicMeta.filter(meta => meta.key === field);
      if (exist && exist.length > 0) {
        return exist[0];
      } else {
        return dynamicMeta;
      }
    }
    return dynamicMeta;
  }
  saveDynamicMetaValue(receivedToggleValue, field) {
    if (this.pageData.metadata.dynamicMeta) {
      const index = this.pageData.metadata.dynamicMeta.filter(meta =>
        meta.key === field
      );
      if (index && index.length > 0) {
        this.pageData.metadata.dynamicMeta.forEach((meta, i) => {
          if (meta.key === field) {
            this.pageData.metadata.dynamicMeta[i].value = receivedToggleValue.value;
          }
        })
      } else {
        this.pageData.metadata.dynamicMeta.push(receivedToggleValue);
      }
    } else {
      this.pageData.metadata.dynamicMeta = [];
      this.pageData.metadata.dynamicMeta.push(receivedToggleValue);
    }
  }
  customFunc(ev) {
  }

  deleteBreakingNews() {
    this.pageData.breakingNewsId = null;
  }
  getPageUrl(url){
    if(this.pageData && this.pageData.status && this.pageData.status !== 'KILLED') {
      if(url && url.indexOf('https://') < 0) {
        if(this.sharedService.checkUrl(url)){
          return url;
        } else {
          if(!this.sharedService.currentDomainUrl){
            let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
            if(obj && obj[0] && obj[0].baseUrl)
              return obj[0].baseUrl + url;
            return url;
          } else {
            return this.sharedService.currentDomainUrl + url;
          }
        }
      }else if(this.pageData.externalUrl){
        return this.pageData.externalUrl;
      } else {
        return '';
      }
    } else {
      return this.pageData.redirectUrl;
    }
  }


  copyPageUrl() {
    let domainUrl=this.sharedService.currentDomainUrl;
    if(domainUrl){
      let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
      if(obj && obj[0] && obj[0].baseUrl)
      domainUrl = obj[0].baseUrl;
      return '';
    } else {
      domainUrl = this.sharedService.currentDomainUrl;
    }
  }

  generateAutoSave()
  {
    this.generatePageAutoSaveInterval();
  }

  destroyAutoSave()
  {
    this.destroyPageAutoSaveInterval();
  }

  switchToggle()
  {
    this.contentChecked = !this.contentChecked;
  }

}
